import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { ResellerHomepageButtonColorType, ResellerHomepageColorType } from 'swag-common/interfaces';
import classes from './banner.scss';
export const Banner = ({
  headingText,
  bodyText,
  textColorType = ResellerHomepageColorType.LIGHT,
  buttonText,
  buttonColorType,
  buttonTextColorType = ResellerHomepageColorType.LIGHT,
  imgUrl
}) => {
  const isInIFrame = window.self !== window.top;
  const shouldShowTextPlaceholder = isInIFrame && !bodyText;
  const shouldHideImage = !isInIFrame && !imgUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, {
      [classes.withImage]: imgUrl
    })
  }, imgUrl && /*#__PURE__*/React.createElement("div", {
    className: classes.imageMobile
  }, /*#__PURE__*/React.createElement("img", {
    src: imgUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("img", {
    src: imgUrl,
    className: classnames(classes.image, {
      [classes.hideImage]: shouldHideImage
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.textBlock, {
      [classes.withoutImage]: !imgUrl
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.title, {
      [classes.light]: textColorType === ResellerHomepageColorType.LIGHT,
      [classes.dark]: textColorType === ResellerHomepageColorType.DARK,
      [classes.placeholder]: !headingText
    })
  }, headingText || 'Swag Made Easy'), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.text, {
      [classes.light]: textColorType === ResellerHomepageColorType.LIGHT,
      [classes.dark]: textColorType === ResellerHomepageColorType.DARK
    })
  }, shouldShowTextPlaceholder ? 'Write some body copy here...' : bodyText || ''), /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.ALL_SWAG
  }, /*#__PURE__*/React.createElement(Button, {
    type: buttonColorType === ResellerHomepageButtonColorType.SECONDARY ? ButtonType.secondary : ButtonType.primary,
    className: classnames(classes.button, {
      [classes.light]: (buttonTextColorType !== null && buttonTextColorType !== void 0 ? buttonTextColorType : textColorType) === ResellerHomepageColorType.LIGHT,
      [classes.dark]: (buttonTextColorType !== null && buttonTextColorType !== void 0 ? buttonTextColorType : textColorType) === ResellerHomepageColorType.DARK
    }),
    isButtonTag: false
  }, buttonText || 'Shop Products')))));
};